import { simplePath } from "../utils.js";
const GET_ORG_PROJECT_LIST_PATH = "/v2/organization/:organization/project-list";
function get_org_project_list_path(params) {
    return simplePath(GET_ORG_PROJECT_LIST_PATH, params);
}
export { GET_ORG_PROJECT_LIST_PATH, get_org_project_list_path };
